export default "__VITE_ASSET__BaaKmGYc__"